require('./_vgformsender');

$(document).ready(function () {
	$('form').submit(function () {
		let $btn = $(this).find('button[type=submit]');
		let textLoading = $btn.data('loading-text');
		if (textLoading) {
			$btn.text(textLoading).attr('disabled', 'disabled');
		}
	});
});